import moment from 'moment'
import { decodeHtmlEntities } from '@opallabs/lambda'

const normalizeTimestamp = (value) => {
  if (!value) return value
  if (moment.isMoment(value)) return value.format()
  if (value instanceof Date) return value.toISOString()
  return value
}

export const setPostMetaData = (postJson) => ({
  content: decodeHtmlEntities(postJson.content),
  postType: postJson.post_type,
  richTextDocumentId: postJson.rich_text_document_id,
  scheduledAt: normalizeTimestamp(postJson.scheduled_at),
  systemScheduledAt: normalizeTimestamp(postJson.system_scheduled_at),
  timezone: postJson.scheduled_at_timezone,
})
